import Calculate from "./calculate";

export default Calculate